import { render } from "./MenuListComponentOld.vue?vue&type=template&id=0c62047f&scoped=true"
import script from "./MenuListComponentOld.vue?vue&type=script&lang=js"
export * from "./MenuListComponentOld.vue?vue&type=script&lang=js"

import "./MenuListComponentOld.vue?vue&type=style&index=0&id=0c62047f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c62047f"]])

export default __exports__